
import { reactApi, reactElement } from "../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { createObj } from "../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { concat, join } from "../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { ofArray } from "../fable_modules/fable-library-js.5.0.0-rc.2/List.js";

export function Checkbox(props) {
    let elems;
    return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "items-center"])], (elems = [reactElement("input", {
        "data-test-id": props.TestId,
        className: join(" ", ["cursor-pointer", "w-4", "h-4", "text-blue-600", "bg-white", "border-[#808080]", "border-2", "rounded-sm", "accent-primary"]),
        type: "checkbox",
        id: concat("checkbox-", props.Label, "-", ...props.TestId),
        checked: props.IsChecked,
        onChange: (ev) => {
            props.OnCheck(ev.target.checked);
        },
        disabled: props.ComponentState === "disabled",
    }), reactElement("label", {
        className: join(" ", ["ml-2", "text-sm"]),
        children: props.Label,
        htmlFor: concat("checkbox-", props.Label, "-", ...props.TestId),
    })], ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

